import { Component, Input, ViewEncapsulation } from "@angular/core"

@Component({
    selector: "app-modal-backdrop",
    template: ``,
    encapsulation: ViewEncapsulation.None,
    host: {
        "[class]": '"modal-backdrop show" + (backdropClass ? " " + backdropClass : "")',
        style: "z-index: 1050",
    },
})
export class ModalBackdropComponent {
    @Input() backdropClass: string
}
